import { CalendarMonthOutlined } from "@mui/icons-material"
import { useTranslation } from "react-i18next"
import { M_Fieldset } from "src/M_Components"
import { QuoteFormField } from "./QuoteFormField"

export const QuoteDates = ({ dataState, setDataState, hideDueDate = false }) => {
  const { t } = useTranslation()

  const formFields = [
    {
      display: t("StartDate"),
      required: true,
      code: "startDate",
      type: "date",
    },
    ...(hideDueDate ? [] : [{ display: t("DueDate"), required: true, code: "dueDate", type: "date" }]),
    { display: t("ValidTo"), required: true, code: "expireDate", type: "date" },
  ]

  return (
    <>
      <M_Fieldset
        labelInside
        label={
          <div
            style={{
              display: "flex",
              alignItems: "center",
              fontSize: "25px",
              marginLeft: "10px",
            }}
          >
            <CalendarMonthOutlined
              style={{ marginRight: "10px", scale: "1.3" }}
            />{" "}
            {t("Dates")}
          </div>
        }
        elements={
          <div
            style={{
              display: "grid",
              justifyContent: "space-evenly",
            }}
          >
            {formFields.map((field, index) => (
              <QuoteFormField
                key={`quote-date-${field.code}`}
                fields={field}
                index={index}
                data={dataState}
                setData={setDataState}
                toggleable={dataState.isRevisionView ? false : dataState.isMultiEdit}
                disabled={dataState.isRevisionView}
              />
            ))}
          </div>
        }
      />
    </>
  )
}
